import { createContext, use } from 'react';

import { UserDto, UserRoleDto } from '@/api/generated';
import { SelectSearchOptionModel } from '@/components/form/model/SelectSearchOption.model.ts';

export type UserContextProps = UserDto & {
  userSelectOption: SelectSearchOptionModel;
};

export const UserDefaultValues: UserContextProps = {
  email: '',
  firstName: '',
  lastName: '',
  role: UserRoleDto.Recruiter,
  userId: '',
  userSelectOption: { label: '', value: '' },
};

export const UserContext = createContext<UserContextProps>(UserDefaultValues);

export const useUserContext = (): UserContextProps => {
  return use(UserContext);
};
